import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewEncapsulation,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { Chapter, Question } from "src/app/models/game";

@Component({
  selector: "app-question-container",
  templateUrl: "./question-container.component.html",
  styleUrls: ["./question-container.component.scss"],
  // tslint:disable-next-line: use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class QuestionContainerComponent implements OnInit {
  buttonDisabled = false;
  correctSound = new Audio();
  wrongSound = new Audio();
  completedSound = new Audio();
  @Input() chapterDetails: Chapter;
  @Input() useKanji: boolean;
  @Input() useSound: boolean;
  @Input() questions: Array<Question>;
  @Input() currentQuestion: number;
  @Input() amountCorrect: number;
  @Input() questionsWrongList = [];
  @Input() isReviewingWrongAnswers: boolean;
  @Input() studyMethod: string;
  @Output() addQuestionToWrongList = new EventEmitter();
  @Output() verify = new EventEmitter();
  @Output() restart = new EventEmitter();
  @Output() toggleKanji = new EventEmitter();
  @Output() toggleSound = new EventEmitter();
  @ViewChild("answer1", { static: false }) answer1: ElementRef;
  @ViewChild("answer2", { static: false }) answer2: ElementRef;
  @ViewChild("answer3", { static: false }) answer3: ElementRef;

  constructor() {}

  ngOnInit() {
    this.correctSound.src = "../../study/assets/correct.wav";
    this.wrongSound.src = "../../study/assets/wrong.mp3";
    this.completedSound.src = "../../study/assets/complete.mp3";
    this.correctSound.load();
    this.wrongSound.load();
    this.completedSound.load();
  }

  verifyAnswer(question, choice) {
    this.buttonDisabled = true;
    if (question.answers[choice - 1].correct) {
      this.highlightChoice(choice, "correct");
      if (this.useSound) {
        this.correctSound.play();
      }
      this.amountCorrect++;
    } else {
      this.highlightChoice(choice, "wrong");
      if (this.useSound) {
        this.wrongSound.play();
      }
      this.addQuestionToWrongList.emit(question);
    }
    setTimeout(() => {
      this.clearHighlights();
      this.currentQuestion++;
      this.buttonDisabled = false;
      if (this.currentQuestion === this.questions.length) {
        if (this.useSound) {
          this.completedSound.play();
        }
      }
    }, 300);
  }

  highlightChoice(choice: number, highlight) {
    if (choice === 1) {
      this.answer1.nativeElement.classList.add(highlight);
    } else if (choice === 2) {
      this.answer2.nativeElement.classList.add(highlight);
    } else if (choice === 3) {
      this.answer3.nativeElement.classList.add(highlight);
    }
  }

  clearHighlights() {
    if (this.answer1) {
      this.answer1.nativeElement.classList.remove("correct");
      this.answer1.nativeElement.classList.remove("wrong");
    }
    if (this.answer2) {
      this.answer2.nativeElement.classList.remove("correct");
      this.answer2.nativeElement.classList.remove("wrong");
    }
    if (this.answer3) {
      this.answer3.nativeElement.classList.remove("correct");
      this.answer3.nativeElement.classList.remove("wrong");
    }
  }

  reviewWrongAnswers() {
    this.currentQuestion = 0;
    this.amountCorrect = 0;
    this.questionsWrongList = [];
    this.restart.emit("review");
  }

  restartGame() {
    this.currentQuestion = 0;
    this.amountCorrect = 0;
    this.restart.emit("restart");
  }
}
